import type { Method } from 'axios'
import type { AppParams } from 'mobx/Infra/Infra.type'
import type { LanguageLocale } from 'utils/language'
import { sendRequest } from 'utils/utils'
import { tenantUrls, TenantUrlPickOptions } from 'utils/api/storefrontUrls'

const makeRequest = async (
	config: string | string[][] | Record<string, string> | URLSearchParams | undefined,
	paramsJson: AppParams,
	httpMethod: Method = 'get'
) => {
	let queryString = ''
	const isGETMethod = httpMethod.toLocaleLowerCase() === 'get'
	if (isGETMethod) {
		queryString = `&${new URLSearchParams(config).toString()}`
	}

	const urls = await tenantUrls([TenantUrlPickOptions.WebFlowAddressURL], paramsJson.c || paramsJson.pc)
	const url = `${urls.webFlowAddressURL}${queryString}`

	return sendRequest(
		false,
		url,
		httpMethod,
		isGETMethod ? null : config,
		isGETMethod ? null : { 'content-type': 'application/x-www-form-urlencoded;charset=utf-8' },
		true,
		90000,
		null,
		false
	)
}

export const getLogo = async (lang: LanguageLocale, params: AppParams) =>
	makeRequest(
		{
			lang,
			type: 'getLogo',
			cust: 'openRest',
		},
		params
	)

export const getLocale = async (lang: LanguageLocale, params: AppParams) =>
	makeRequest(
		{
			lang,
			type: 'getLocale',
			cust: 'openRest',
		},
		params
	)

export const getAllChainStores = async (lang: LanguageLocale, params: AppParams) =>
	makeRequest(
		{
			lang,
			type: 'getBranchesList',
			noFilter: 'true',
			cust: 'openRest', // <- this parameter seem to have no effect on the api (it returns same results without it)
		},
		params
	)

/**
 *
 * addressObj: { formatted: string, latLng: { lat: number, lng: number}, addressVal: string}
 */
export const getChainStoresByAddress = async (
	chainId: string,
	addressObj: { formatted: string; latLng: Record<string, string>; addressVal: string },
	lang: LanguageLocale,
	params: AppParams
) =>
	makeRequest(
		{
			chainId,
			lang,
			type: 'getBranchesList',
			noFilter: 'true',
			cust: 'openRest',
			filterRadius: 'true',
			cb: Date.now().toString(),
			addr: {
				formatted: addressObj.formatted,
				...addressObj.latLng,
			},
			addressVal: addressObj.addressVal,
		} as unknown as Record<string, string>,
		params,
		'post'
	)

export const getLimitedOffers = async (chainId: string, lang: LanguageLocale, params: AppParams) =>
	makeRequest(
		{
			lang,
			type: 'getFeaturedItems',
			cust: 'openRest',
		},
		params
	)
